/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatListItemLastMessageDirection = typeof LinkedInChatListItemLastMessageDirection[keyof typeof LinkedInChatListItemLastMessageDirection] | null;


export const LinkedInChatListItemLastMessageDirection = {
  inbound: 'inbound',
  outbound: 'outbound',
} as const;
